module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l9MxB"))).then(() => parcelRequire('d0iPb'));